<template>
  <div class="content">
    <div v-if="doctorArea && doctorArea.length">
      <div class="area-title">
        医生工作区
      </div>
      <div class="home">
        <div class="list" v-for="item in doctorArea" @click="changeRouter(item.url)">
          <div class="img">
            <img :src="item.img" alt="">
          </div>
          <div class="title">{{ item.menu_name }}</div>
        </div>
      </div>
    </div>

    <div v-if="pharmacyArea && pharmacyArea.length">
      <div class="area-title">
        药房工作区
      </div>
      <div class="home">
        <div class="list" v-for="item in pharmacyArea" @click="changeRouter(item.url)">
          <div class="img">
            <img :src="item.img" alt="">
          </div>
          <div class="title">{{ item.menu_name }}</div>
        </div>
      </div>
    </div>

    <div v-if="csArea && csArea.length">
      <div class="area-title">
        客服工作区
      </div>
      <div class="home">
        <div class="list" v-for="item in csArea" @click="changeRouter(item.url)">
          <div class="img">
            <img :src="item.img" alt="">
          </div>
          <div class="title">{{ item.menu_name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {wxtriageworkbenchqry} from '@/api/medical'
import { mapGetters } from 'vuex'
export default{
    computed: {
        ...mapGetters([
            'username','dispname','clinicid'
        ]),
    },
    data(){
        return{
            doctorArea:[],
            pharmacyArea:[],
            csArea:[]
        }
    },
    created(){
        this.$store.dispatch('hideOrShowNav', true)
        this.getmenu()
    },
    beforeRouteLeave(to, from, next){

        this.$store.dispatch('changeIsRefresh', '1')

        next()
    },
    methods:{
        changeRouter(url){
            console.log(url);
            if(url){
                if(url=='/processDispensing'){
                    this.$router.push({path:'/dispensing',query:{isprocess:1}})
                  return
                }
                if (url == '/chargeWorkbench'){
                  this.$store.dispatch('changeIsRefresh', '1')
                }
                this.$router.push(url)
            }
        },
        getmenu(){
            let data ={
                username:this.username
            }
            wxtriageworkbenchqry(data).then(response =>{

                this.doctorArea = response.response_body.list
                    .filter(item => ['treatWorkbench', 'visitWorkbench','aiIdentify'].includes(item.menu_code))
                    .map(item => {
                    if(item.menu_code == 'treatWorkbench'){
                        item.url = '/treatPage'
                        item.img = require('@/assets/physicalwork.png')
                    }else if(item.menu_code == 'visitWorkbench'){
                        item.url = '/seePage'
                        item.img = require('@/assets/visitwork.png')
                    }else if(item.menu_code == 'aiIdentify'){
                      item.url = '/aiIdentify'
                      item.img = require('@/assets/aiIdentify.png')
                    }
                    return item
                })

              this.pharmacyArea = response.response_body.list
                  .filter(item => ['dispensing', 'processDispensing'].includes(item.menu_code))
                  .map(item => {
                    if(item.menu_code == 'dispensing'){
                      item.url = '/dispensing'
                      item.img = require('@/assets/dispensing.png')
                    }else if(item.menu_code == 'processDispensing'){
                      item.url = '/processDispensing'
                      item.img = require('@/assets/processDispensing.png')
                    }
                    return item
                  })

              this.csArea = response.response_body.list
                  .filter(item => ['reportTriage', 'bookingManagement', 'patientList','chargeWorkbench'].includes(item.menu_code))
                  .map(item => {
                    if(item.menu_code == 'reportTriage'){
                      item.url = '/registrationDesk'
                      item.img = require('@/assets/reportTriage.png')
                    }else if(item.menu_code == 'bookingManagement'){
                      item.url = '/bookingManagement'
                      item.img = require('@/assets/bookingManagement.png')
                    }else if(item.menu_code == 'patientList'){
                      item.url = '/patientList'
                      item.img = require('@/assets/patientlist.png')
                    }else if(item.menu_code == 'chargeWorkbench'){
                      item.url = '/chargeWorkbench'
                      item.img = require('@/assets/chargePage.png')
                    }
                    return item
                  })

            })

        }
    }
}

</script>
<style lang="scss" scoped>
.content{
  margin: 20px;
}
.area-title{
  font-size: 16px;
  font-weight: bold;
}
.home{
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;

    .list{
        width: 33%;
        text-align: center;
        margin-bottom: 40px;
        .img{
            display: flex;
            justify-content: center;
        }
        img{
            width: 50px;
            height: 50px;
            border-radius: 50px;
        }
    }
}
</style>
